var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$auth && !_vm.$auth.ready())?_c('loading',{attrs:{"branding":true,"overlay":true}}):_vm._e(),(!_vm.$auth || _vm.$auth.ready() && _vm.$auth.check())?_c('home-page',{attrs:{"previewMessageId":_vm.previewMessageId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }